module.exports = __webpack_public_path__ + "img/6.6d3a7b36.webp";